export default {
  required: {
    id: 'dynamic_field_validator_field_required',
    defaultMessage: 'This field is required',
  },
  fieldTooShort: {
    id: 'dynamic_field_validator_field_too_short',
    defaultMessage: 'This field should be at least {length} characters',
  },
  fieldTooLong: {
    id: 'dynamic_field_validator_field_too_long',
    defaultMessage: 'This field should be less than {length} characters',
  },
  incorrectFormat: {
    id: 'dynamic_field_validator_field_invalid_format',
    defaultMessage: 'The format of this field is incorrect',
  },
  notInTheRange: {
    id: 'dynamic_field_validator_field_not_in_the_range',
    defaultMessage: 'This field is out of range',
  },
  wrongBooleanValue: {
    id: 'dynamic_field_validator_field_wrong_boolean_value',
    defaultMessage: 'The value of this field is incorrect',
  },
}
